angular.module("avant.customer_applications.directives").directive "toggleProductTypeByState", ->

  link: ($scope, element, attributes) ->

    showProductTypesForState = (state) ->
      $scope.installment_visible = false
      $scope.credit_line_visible = false

      old_product_type = $scope.customer_application.product_type

      if state_hash && state_hash[state]
        for product_type in state_hash[state]
          if state_hash[state].length > 1
            $scope["#{product_type}_visible"] = true
          unless _.contains(state_hash[state], $scope.customer_application.product_type)
            $scope.customer_application.product_type = product_type

      if old_product_type isnt $scope.customer_application.product_type
        $scope.update('customer_application.product_type')

    expression = attributes.toggleProductTypeByState
    state_hash = JSON.parse attributes.toggleProductTypeByStateHash

    $scope.$watch expression, (newValue, oldValue) ->
      return if newValue is oldValue and !newValue # Ignore first-run values since we've already defaulted the element state.
      showProductTypesForState(newValue)

  restrict: "A"

{ "IL": ["installment", "credit_line"] }